const allowRoutesMiddleware = ['/ping'];

export default allowRoutesMiddleware;
